module.exports = __webpack_public_path__ + "40cc28513bc4ef1e5cd49172f7fbce51.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/imgs/Arbeitslosenquote.svg
// module id = 259
// module chunks = 1